<template>
    <div>
        <el-alert title="省平台数据导出后无需改动直接上传即可" type="info" show-icon></el-alert>
        <div v-show="!saveOrUpdate.visible&&!look.visible">
            <!--搜索表单-->
            <div class="search-box">
                <el-form ref="searchForm" :rules="rules"  :inline="true" :model="searchForm" >
                    <el-form-item label="注册年份:" prop="year">
                        <el-date-picker
                                size="mini"
                                v-model="searchForm.year"
                                type="year"
                                placeholder="选择注册年份"
                                format="yyyy"
                                value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="考生姓名:" prop="name">
                        <el-input size="mini" v-model="searchForm.name" placeholder="请输入考生姓名"></el-input>
                    </el-form-item>
                  <el-form-item label="考生类型:" prop="studentType">
                    <el-input size="mini" v-model="searchForm.studentType" placeholder="请输入考生类型"></el-input>
                  </el-form-item>
                    <el-form-item label="身份证号:" prop="idCard">
                        <el-input size="mini" v-model="searchForm.idCard" placeholder="请输入身份证号"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业学校:" prop="unicerColleges">
                        <el-input size="mini" v-model="searchForm.unicerColleges" placeholder="请输入毕业学校"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业专业:" prop="studyMajor">
                        <el-input size="mini" v-model="searchForm.studyMajor" placeholder="请输入毕业专业"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudentIn-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                        <el-button plain size="mini" type="warning" icon="el-icon-refresh-left" @click="clear">清空</el-button>
                      <el-button size="mini" plain type="success" v-display:sysStudentIn-batchUploadZip icon="el-icon-upload" @click="batchUploadZip" >考生照片压缩上传</el-button>
                      <el-button size="mini" plain type="success" v-display:sysStudentIn-batchUploadImg icon="el-icon-upload" @click="batchUploadImg" >考生照片上传</el-button>
                      <el-button size="mini" plain type="primary" v-display:sysStudentIn-batchNoSubmit icon="el-icon-s-promotion" @click="batchSubmit(0)" >批量不发布</el-button>
                      <el-button size="mini" plain type="danger" v-display:sysStudentIn-batchSubmit icon="el-icon-s-promotion" @click="batchSubmit(1)" >批量发布</el-button>
                      <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                      <el-button plain size="mini" type="primary" v-display:sysStudentIn-save icon="el-icon-plus" @click="toSaveOrUpdate" >新增</el-button>
                      <el-dropdown>
                        <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                          批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-display:sysStudentIn-batchDelete icon="el-icon-delete" @click.native="batchDelete" >批量删除</el-dropdown-item>
                          <el-dropdown-item v-display:sysStudentIn-leadingIn icon="el-icon-upload" @click.native="leadingInSysStudentIn">导入</el-dropdown-item>
                          <el-dropdown-item v-display:sysStudentIn-export icon="el-icon-download" @click.native="exportSysStudentIn">导出</el-dropdown-item>
                          <el-dropdown-item v-display:sysStudentIn-exportField icon="el-icon-download" @click.native="exportSysStudentInDialog">导出选择字段</el-dropdown-item>
                          <el-dropdown-item v-display:sysStudentIn-exportModule icon="el-icon-download" @click.native="exportSysStudentInModule('upsertForm')">下载模板</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-form-item>
                </el-form>
             </div>
            <!--表格-->
            <el-table border size="mini" class="table-ui" :stripe="true" height="70vh" :data="tableData" @selection-change="changeFun"   @sort-change="sortChange" >
                <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态" width="60">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="已发布" placement="top" v-if="scope.row.status==1">
                            <span class="el-icon-success" style="font-size: 20px;color: green"></span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="未发布" placement="top" v-else-if="scope.row.status==0" >
                            <span class="el-icon-remove" style="font-size: 20px;color: #5db3ce"></span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="发布异常，请查看发布备注" placement="top" v-else >
                            <span class="el-icon-error" style="font-size: 20px;color: #ff5c4f"></span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="msg" label="发布备注"></el-table-column>
                <el-table-column show-overflow-tooltip prop="faceImg" label="头像" >
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.faceImg" style="width: 50px; height: 50px;border-radius: 100%" :src="config.resPre+scope.row.faceImg" :preview-src-list="[config.resPre+scope.row.faceImg]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="name" label="考生姓名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studentType" label="考生类型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="birthday" label="出生日期"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sex" label="性别"></el-table-column>
                <el-table-column show-overflow-tooltip prop="nation" label="民族"></el-table-column>
                <el-table-column show-overflow-tooltip prop="politicalAffiliation" label="政治面貌"></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCard" label="身份证号" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="archivesCardProvince" label="建档立卡所在省" width="110"></el-table-column>
                <el-table-column show-overflow-tooltip prop="univerColleges" label="毕业学校"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studyMajor" label="毕业专业"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studyColleges" label="报考学校"></el-table-column>
                <el-table-column show-overflow-tooltip prop="studyCollegesCode" label="报考学校代码" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajor" label="报考专业"></el-table-column>
                <el-table-column show-overflow-tooltip prop="examMajorCode" label="报考专业代码" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="homeAddress" label="家庭住址"></el-table-column>
                <el-table-column show-overflow-tooltip prop="address" label="联系地址"></el-table-column>
                <el-table-column show-overflow-tooltip prop="adressCode" label="邮编" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="联系电话" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="reward" label="所获奖励"></el-table-column>
                <el-table-column show-overflow-tooltip prop="speciality" label="特长"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endSchoolCode" label="毕业证书"></el-table-column>
                <el-table-column show-overflow-tooltip prop="joinArmyTime" label="入伍时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endArmyTime" label="退役时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endArmyCode" label="退役编号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="endArmyAdress" label="退役安置"></el-table-column>
                <el-table-column show-overflow-tooltip prop="code" label="报名号" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="year" label="年份" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200"  >
                    <template slot-scope="scope">
                        <el-button style="color: green" v-display:sysStudentIn-submitStudent  type="text" icon="el-icon-success" @click="submitStudent(scope.row.id,1)">发布</el-button>
                        <el-button style="color: #497eff" v-display:sysStudentIn-noSubmitStudent  type="text" icon="el-icon-error" @click="submitStudent(scope.row.id,0)">不发布</el-button>
                        <el-dropdown style="margin-left: 10px">
                            <span class="el-dropdown-link" style="color: #409EFF">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item><el-button type="text" v-display:sysStudentIn-update @click="toSaveOrUpdate($event,scope.row.id)">修改</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysStudentIn-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                                <el-dropdown-item><el-button type="text" v-display:sysStudentIn-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
            <el-pagination
                    style="margin-top: 10px;padding-bottom: 20px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="searchForm.pager.totalCount"
                    :page-size="searchForm.pager.pageSize"
                    :current-page.sync="searchForm.pager.page"
                    :page-sizes="[10, 20, 30, 40, 50, 100,500]"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
            ></el-pagination>
            <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
                <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <!--表格-->
                <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column show-overflow-tooltip prop="errorMsg" label="导入备注" width="200">
                        <template slot-scope="scope">
                            <span style="color: red">{{scope.row.errorMsg}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="name" label="考生姓名"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="phone" label="联系电话"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="adressCode" label="邮编"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="examMajor" label="报考专业"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="subjectOneName" label="科目一"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="subjectTwoName" label="科目二"></el-table-column>
                </el-table>
            </div>
                <div v-if="dialogExcel.title=='导入'">
                    <el-upload class="lead-in-th"
                               style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                               :action="uploadUrl"
                               :headers="headers"
                               multiple
                               :show-file-list="false"
                               :on-success="handleSysStudentInSuccess"
                               :before-upload="beforeSysStudentInUpload">
                        <div class="" style="width: 440px;height: 50px;">导入</div>
                    </el-upload>
                    <div class="lead-in-th" @click="exportSysStudentInModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
                </div>
            </el-dialog>
            <!--选择字段导出-->
            <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
               <div style="height: 400px;overflow-y: auto;width: 100%" >
                   <!--表格-->
                   <el-table border :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                       <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                       <el-table-column prop="key" label="英文字段名" ></el-table-column>
                       <el-table-column prop="name" label="中文字段名" ></el-table-column>
                       <el-table-column prop="newName" label="重命名字段" >
                           <template slot-scope="scope">
                               <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                           </template>
                       </el-table-column>
                   </el-table>
               </div>
                <div slot="footer" class="dialog-footer">
                    <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                    <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysStudentInByField">确认导出</el-button>
                </div>
            </el-dialog>
            <!--查看目录结构-->
            <el-dialog :close-on-click-modal="false"  :title="dialogUpLoadUpFile.title"   width="700px" :visible.sync="dialogUpLoadUpFile.dialogFormVisible">
                <el-alert title="系统提示:考生照片文件名必须为身份证号如果不匹配则不会生效，重复则覆盖" type="success" show-icon></el-alert>
                <div style="text-align: center;margin: auto;height: 500px;overflow-y: scroll">
                    <el-upload ref="upload" class="upload-demo" drag :headers="{token:$store.getters.getToken}"
                               :action="uploadFileUrl" multiple
                               :on-preview="handlePreview"
                               :on-remove="handleRemove"
                               :on-exceed="handleExceed"
                               :on-success="handleAvatarSuccess"
                               :before-remove="beforeRemove"
                               :on-error="uploadError"
                               :before-upload="beforeUpload"
                               accept=".png,.jpg,.PNG,.JPG,.jpeg,.JPEG"
                               :file-list="resourcesList">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">
                            <p style="font-size: 12px;color: red">允许上传文件类型:.png,.jpg,.PNG,.JPG,.jpeg,.JPEG</p>
                            <p>单个文件上传不能超过6MB</p>
                        </div>
                    </el-upload>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button plain size="mini"  @click="dialogUpLoadUpFile.dialogFormVisible = false">取 消</el-button>
                    <el-button plain size="mini"  type="primary" @click="saveOrUpdateFile">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" :title="dialogZip.title"   width="650px" :visible.sync="dialogZip.dialogFormVisible">
                <el-input v-model="dialogZip.suffix" size="mini" placeholder="请输入前缀"></el-input>
                <el-upload class="lead-in-th"
                       style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                       :action="uploadZipUrl"
                       :headers="headers"
                           :data="{'suffix':dialogZip.suffix}"
                       :show-file-list="false"
                       :on-success="handleSysStudentInZipSuccess"
                       :before-upload="beforeSysStudentInZipUpload"
                        accept=".zip">
                    <div class="" style="width: 440px;height: 50px;">上传考生照片zip文件</div>
                </el-upload>
            </el-dialog>
        </div>
        <save-or-update-sys-student-in v-if="saveOrUpdate.visible" v-bind="saveOrUpdate" @closeSaveOrUpdate="closeSaveOrUpdate"></save-or-update-sys-student-in>
        <look-sys-student-in v-if="look.visible" v-bind="look" :visible.sync="look.visible"></look-sys-student-in>
    </div>
</template>

<script>
    import axios from 'axios';
    import saveOrUpdateSysStudentIn from './saveOrUpdateSysStudentIn';
    import lookSysStudentIn from './lookSysStudentIn';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysStudentIn",
        components:{saveOrUpdateSysStudentIn,lookSysStudentIn,noData},
        data() {
            return {
                searchForm:{
                      adminId: '',
                      adminName: '',
                      msg:'',
                      faceImg: '',
                      name: '',
                      studentType: '',
                      birthday: '',
                      sex: '',
                      nation: '',
                      politicalAffiliation: '',
                      idCard: '',
                      archivesCardProvince: '',
                      univerColleges: '',
                      studyMajor: '',
                      studyColleges: '',
                      studyCollegesCode: '',
                      examMajor: '',
                      examMajorCode: '',
                      homeAddress: '',
                      address: '',
                      adressCode: '',
                      phone: '',
                      reward: '',
                      speciality: '',
                      endSchoolCode: '',
                      joinArmyTime: '',
                      endArmyTime: '',
                      endArmyCode: '',
                      endArmyAdress: '',
                      year: '',
                      updateTime: '',
                      createTime: '',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'name,idCard,unicerColleges,studyMajor,studentType',
                    }
                },
                tableData: [],
                saveOrUpdate:{
                    visible:false,
                    title:'增加',
                    id:''
                },
                look:{
                    visible:false,
                    id:''
                },
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysStudentIn/importByExcel`,
                uploadZipUrl: `${home}/sysStudentIn/uploadZip`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                dialogZip:{
                    dialogFormVisible:false,
                    title:'考生照片ZIP上传',
                    suffix:'',
                },
                rules: {
                          adminId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          faceImg: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          name: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentType: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          birthday: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          sex: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          nation: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          politicalAffiliation: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCard: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          archivesCardProvince: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          univerColleges: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyMajor: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyColleges: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studyCollegesCode: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examMajor: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          examMajorCode: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          homeAddress: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          address: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adressCode: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          phone: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          reward: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          speciality: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          endSchoolCode: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          joinArmyTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          endArmyTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          endArmyCode: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          endArmyAdress: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          year: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                statusMap:["已报名（待审核）","审核通过","审核不通过"],
                statusMapIcon:["el-icon-warning","el-icon-success","el-icon-error"],
                statusMapColor:["#5561ff","#79ff25","#ff4520"],
                config:config,
                yearList:[],
                univerCollegesList:[],
                majorList:[],
                schoolMajorList:[],
                uploadFileUrl: `${home}/sysStudentIn/uploadFile`,
                resourcesList:[],
                dialogUpLoadUpFile:{
                    dialogFormVisible:false,
                    title:'上传考生照片',
                    id:'',
                },
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
            this.getDdUniverAndMajorList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            toSaveOrUpdate($event,id){
                if(id){
                    this.saveOrUpdate.title='修改';
                    this.saveOrUpdate.id=id;
                }else{
                    this.saveOrUpdate.title='增加';
                }
                this.saveOrUpdate.visible=true;
            },
            closeSaveOrUpdate(data){
                this.saveOrUpdate.visible=false;
                data&&this.submit();
            },
            toLook($event,id){
                this.look={
                    visible:true,
                    id:id
                }
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentIn/deleteSysStudentIn/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })

                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysStudentIn/findSysStudentInsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            leadingInSysStudentIn() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysStudentIn() {
                axios({
                    url: `${home}/sysStudentIn/exportSysStudentIn`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysStudentIn.xls");
                });
            },
            exportSysStudentInModule() {
                axios({
                    url: `${home}/sysStudentIn/exportSysStudentInModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysStudentIn模板.xls");
                });

            },
            handleSysStudentInSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysStudentInUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentIn/batchDeleteSysStudentIn`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysStudentInDialog(){
                axios({
                    url: `${home}/sysStudentIn/getSysStudentInTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });
            },
            exportSysStudentInByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysStudentIn/exportSysStudentInByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "sysStudentIn.xls");
                    });
                }

            },
            getDdUniverAndMajorList(){
                axios({
                    url:`${home}/sysDdList/getDdUniverAndMajorList`,
                    method:'GET'
                }).then(res=>{
                    this.univerCollegesList = res.data;
                    this.majorList = res.data2;
                }).catch(error=>{

                })
            },
            getSchoolMajorList(code){
                this.searchForm.studyMajorId = '';
                axios({
                    url:`${home}/sysDdList/getSchoolListByCode/${code}`,
                    method:'GET'
                }).then(res=>{
                    this.schoolMajorList = res.data;
                }).catch(error=>{

                })
            },
            submitStudent(id,status){
                this.$confirm("确认"+(status==1?"发布":"不发布")+"该学生吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url:`${home}/sysStudentIn/submitStudent/${id}/${status}`,
                        method:'GET'
                    }).then(res=>{
                        this.$message({
                            type: "success",
                            message: (status==0?"不发布":"发布")+"成功!"
                        });
                        this.submit();
                    }).catch(error=>{

                    })
                }).catch(() => {
                    this.$message({
                        type: "warning",
                        message: "取消操作!"
                    });
                });
            },
            batchSubmit(status){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量提交吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentIn/batchSubmitSysStudentIn`,
                        method: "post",
                        data: {
                            rowData: this.rowData,
                            "status":status
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "批量发布成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "warning",
                        message: "取消批量发布!"
                    });
                });
            },
            batchUploadImg(){
                this.dialogUpLoadUpFile.dialogFormVisible = true;
            },
            handleRemove(file, fileList) {
                this.resourcesList = [];
                for(var i=0;i<fileList.length;i++){
                    if(fileList[i].response){
                        this.resourcesList.push(fileList[i].response.data);
                    }else{
                        this.resourcesList.push(fileList[i]);
                    }
                }
                this.$message.success(`删除成功`);
            },
            beforeUpload(file) {
                var fileSize = file.size / 1024 / 1024;
                if (fileSize > 6) {
                    this.$message.error(`单个文件上传大小不能超过 6M`);
                    return false;
                }
            },
            uploadError() {
                this.$message.error('文件大小超出范围或出现服务器问题！！');
                return false;
            },
            handlePreview(file) {
            },
            handleExceed(files, fileList) {
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            handleAvatarSuccess(response, file, fileList) {
                this.resourcesList = [];
                for(var i=0;i<fileList.length;i++){
                    if(fileList[i].response){
                        this.resourcesList.push(fileList[i].response.data);
                    }else{
                        this.resourcesList.push(fileList[i]);
                    }
                }
            },
            saveOrUpdateFile(){
                axios({
                    url: `${home}/sysStudentIn/bachSaveStudentInImg`,
                    method: "POST",
                    data:this.resourcesList
                }).then(res => {
                    this.$message({
                        message: "保存成功",
                        type: "success"
                    });
                    this.submit();
                    this.dialogUpLoadUpFile.dialogFormVisible = false;
                });
            },
            batchUploadZip(){
                this.dialogZip.dialogFormVisible = true;
            },
            handleSysStudentInZipSuccess(res, file) {
                this.loading.close();
                this.dialogZip.dialogFormVisible = false;
                if (res.result.success== true) {
                    this.$message({
                        message: "上传成功",
                        type: "success"
                    });
                    this.submit();
                } else{
                    this.$message({
                        message: "上传失败",
                        type: "error"
                    });
                    this.dialogZip.dialogFormVisible = true;
                }
            },
            beforeSysStudentInZipUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "zip";
                if (!extension) {
                    this.loading.close();
                    this.$message.error("上传文件只能是 zip 格式!");
                }
                return extension;
            },
        }
    }
</script>
